<template>
  <div class="navMain">
    <div class="navMain--button" @click="navActive">
      <div class="navMain--buttonLine navMain--buttonLine1"></div>
      <div class="navMain--buttonLine navMain--buttonLine2"></div>
      <div class="navMain--buttonLine navMain--buttonLine3"></div>
    </div>
    <ul class="navMain--list">
      <li class="navMain--listItem" @click="navDisable">
        <router-link
        to="/"
        title='Inicio'
        class="navMain--listItemLink">
          Inicio
        </router-link>
      </li>
      <li class="navMain--listItem" @click="navDisable">
        <router-link
        to="/informes"
        title='Informes'
        class="navMain--listItemLink">
          Informes
        </router-link>
      </li>
      <li class="navMain--listItem" @click="navDisable">
        <router-link
        to="/sobre"
        title='Sobre'
        class="navMain--listItemLink">
          Sobre
        </router-link>
      </li>
      <li class="navMain--listItem" @click="navDisable">
        <router-link
        to="/amartyasen"
        title='Amartya Sen'
        class="navMain--listItemLink">
          Amartya Sen
        </router-link>
      </li>
      <li class="navMain--listItem" @click="navDisable">
        <router-link
        to="/publicacoes"
        title='Publicações'
        class="navMain--listItemLink">
          Publicações
        </router-link>
      </li>
      <li class="navMain--listItem" @click="navDisable">
        <router-link
        to="/equipe"
        title='Equipe'
        class="navMain--listItemLink">
          Equipe
        </router-link>
      </li>
      <li class="navMain--listItem" @click="navDisable">
        <router-link
        to="/contato"
        title='Contato'
        class="navMain--listItemLink">
          Contato
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'NavMain',
  methods: {
    navActive () {
      let html = document.body.parentNode
      html.classList.toggle('navActive')
    },
    navDisable () {
      let html = document.body.parentNode
      html.classList.remove('navActive')
    }
  }
}
</script>

<style>

</style>
